<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import errorHandling from "../../../mixins/errorHandling";
import InlineCustomerSearch from "@/components/inline-customer-search.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Transactions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [errorHandling],
  components: { Layout, PageHeader, DatePicker, InlineCustomerSearch },
  data() {
    return {
      transactions: [],
      title: "Transactions",
      items: [
        {
          text: "Agent",
        },
        {
          text: "Transactions",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "customerName", sortable: true, label: "Customer Name" },
        {
          key: "transactionData.changes.transactionDate",
          sortable: true,
          label: "Transaction Date",
        },
        {
          key: "transactionData.changes.transactionAmount",
          sortable: true,
          label: "Transaction Amount (GHS)",
        },
        {
          key: "transactionData.changes.paymentTypeId",
          sortable: true,
          label: "Payment Type",
        },
        { key: "transactionType" },
        { key: "transactionPaymentType", label: "Individaul / Group" },
        { key: "notified" },
        { key: "_id", label: "Reverse Transaction" },
      ],
      loading: false,
      searchQuery: "",
      selectedValues: [],
      individualOrGroup: [],
      paymentType: [],
      // date picker
      dateRange: [new Date(), new Date()],
      // date picker end
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.transactions.length;
    },

    filterCustomer() {
      let filteredTransactions = [...this.transactions]; // Create a copy of transactions

      if (this.searchQuery !== "") {
        const searchQueryLowerCase = this.searchQuery.toLowerCase();
        filteredTransactions = filteredTransactions.filter((transaction) =>
          transaction.customerName.toLowerCase().includes(searchQueryLowerCase)
        );
      }

      if (this.individualOrGroup.length > 0) {
        filteredTransactions = filteredTransactions.filter((transaction) =>
          this.individualOrGroup.includes(transaction.transactionPaymentType)
        );
      }

      if (this.selectedValues.length > 0) {
        filteredTransactions = filteredTransactions.filter((transaction) =>
          this.selectedValues.includes(transaction.transactionType)
        );
      }

      if (this.paymentType.length > 0) {
        filteredTransactions = filteredTransactions.filter((transaction) =>
          transaction?.transactionData?.changes?.paymentTypeId === undefined
            ? false
            : this.paymentType.includes(
                transaction.transactionData.changes.paymentTypeId
              )
        );
      }

      return filteredTransactions;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.getTransactions();
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getTransactions() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${
            process.env.VUE_APP_BASE_URL
          }/agent-transaction/${localStorage.getItem("id")}?limit=100&page=2`
        );
        if (response.status === 200 || response.status === 201) {
          this.transactions = response.data.data.reverse();
          this.loading = false;
        } else {
          this.loading = false;
          this.throwError();
        }
      } catch (error) {
        this.loading = false;
        this.handleError(error.response.data.message);
      }
    },
    formatDate(dd) {
      // Parse the original date string
      const originalDate = new Date(dd);

      const year = originalDate.getFullYear();
      const month = originalDate.getMonth() + 1;
      const day = originalDate.getDate();

      // Format the date in "YYYY-MM-DD" format
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

      return formattedDate; // Output: "2023-10-22"
    },
    async getTransactionsByDate() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${
            process.env.VUE_APP_BASE_URL
          }/agent-transaction/${localStorage.getItem(
            "id"
          )}/filter?startDate=${this.formatDate(
            this.dateRange[0]
          )}&endDate=${this.formatDate(this.dateRange[1])}`
        );
        this.transactions = response.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.handleError(error.response.data.message);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- Global Customer Search -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="text-center mb-3">
          <h5 class="text-muted">Quick Customer Search</h5>
          <p class="text-muted small">
            Search for a customer to verify their payment
          </p>
        </div>
        <InlineCustomerSearch />
      </div>
    </div>

    <div class="row" v-if="loading">
      <b-spinner class="m-2 m-auto" variant="primary" role="status"></b-spinner>
    </div>

    <div class="row" v-else>
      <div class="col-xl-3 col-lg-4">
        <div class="card">
          <div class="card-header bg-transparent border-bottom">
            <h5 class="mb-0">Filters</h5>
          </div>

          <div class="card-body">
            <h5 class="font-size-14 mb-3">Filter By :</h5>

            <div
              id="accordion"
              class="custom-accordion categories-accordion mb-3"
            >
              <div class="categories-group-card">
                <a v-b-toggle.electorinic class="categories-group-list">
                  <i
                    class="mdi mdi-account-star-outline font-size-16 align-middle mr-2"
                  ></i>
                  Customer Name
                  <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                </a>

                <b-collapse
                  id="electorinic"
                  data-parent="#accordion"
                  accordion="my-accordion"
                >
                  <div class="search-box ml-2 mt-4 mb-4">
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control rounded"
                        v-model="searchQuery"
                        placeholder="Customer Name..."
                      />
                      <i class="mdi mdi-magnify search-icon"></i>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <div class="categories-group-card">
                <a
                  v-b-toggle.trans
                  class="categories-group-list"
                  data-toggle="collapse"
                  aria-expanded="true"
                  aria-controls="collapseTwo"
                >
                  <i
                    class="mdi mdi-account-group-outline font-size-16 align-middle mr-2"
                  ></i>
                  Individual/Group
                  <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                </a>
                <b-collapse
                  id="trans"
                  visible
                  data-parent="#accordion"
                  accordion="my-accordion"
                >
                  <div>
                    <div class="custom-control custom-checkbox mb-4 mt-4 ml-1">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck7"
                        v-model="individualOrGroup"
                        value="Individual"
                      />
                      <label class="custom-control-label" for="customCheck7"
                        >Individual</label
                      >
                    </div>
                    <div class="custom-control custom-checkbox mb-4 mt-4 ml-1">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck6"
                        value="Group"
                        v-model="individualOrGroup"
                      />
                      <label class="custom-control-label" for="customCheck6"
                        >Group</label
                      >
                    </div>
                  </div>
                </b-collapse>
              </div>

              <div class="categories-group-card">
                <a
                  v-b-toggle.fashion
                  class="categories-group-list"
                  data-toggle="collapse"
                  aria-expanded="true"
                  aria-controls="collapseTwo"
                >
                  <i class="mdi mdi-cash font-size-16 align-middle mr-2"></i>
                  Transaction Type
                  <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                </a>
                <b-collapse
                  id="fashion"
                  visible
                  data-parent="#accordion"
                  accordion="my-accordion"
                >
                  <div>
                    <div class="custom-control custom-checkbox mb-4 mt-4 ml-1">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck1"
                        v-model="selectedValues"
                        value="SavingsDeposit"
                      />
                      <label class="custom-control-label" for="customCheck1"
                        >Security Deposit</label
                      >
                    </div>
                    <div class="custom-control custom-checkbox mb-4 mt-4 ml-1">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck2"
                        value="LoanPayment"
                        v-model="selectedValues"
                      />
                      <label class="custom-control-label" for="customCheck2"
                        >Loan Payment</label
                      >
                    </div>
                    <div class="custom-control custom-checkbox mb-4 mt-4 ml-1">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck8"
                        value="Withdrawal"
                        v-model="selectedValues"
                      />
                      <label class="custom-control-label" for="customCheck8"
                        >Withdrawal</label
                      >
                    </div>
                  </div>
                </b-collapse>
              </div>

              <div class="categories-group-card">
                <a
                  v-b-toggle.kids
                  class="categories-group-list collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  <i
                    class="mdi mdi-account-cash-outline font-size-16 align-middle mr-2"
                  ></i>
                  Payment Type
                  <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                </a>
                <b-collapse
                  id="kids"
                  data-parent="#accordion"
                  accordion="my-accordion"
                >
                  <div>
                    <div class="custom-control custom-checkbox mb-4 mt-4 ml-1">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck3"
                        v-model="paymentType"
                        value="1"
                      />
                      <label class="custom-control-label" for="customCheck3"
                        >Cash Payment</label
                      >
                    </div>
                    <div class="custom-control custom-checkbox mb-4 mt-4 ml-1">
                      <input
                        type="checkbox"
                        v-model="paymentType"
                        class="custom-control-input"
                        id="customCheck4"
                        value="2"
                      />
                      <label class="custom-control-label" for="customCheck4"
                        >Momo Payment</label
                      >
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-9">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Transactions Table</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div
              class="d-flex justify-content-center align-items-center mt-4 mb-4"
            >
              <div>
                <p></p>
              </div>
              <div class="col-md-6 col-sm-12 row">
                <date-picker
                  v-model="dateRange"
                  type="date"
                  range
                  placeholder="Select date range"
                ></date-picker>
              </div>
              <div>
                <b-button
                  size="sm"
                  variant="secondary"
                  @click.prevent="getTransactionsByDate"
                  >Submit</b-button
                >
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="filterCustomer"
                :fields="fields"
                responsive="sm"
                stacked="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template
                  v-slot:cell(transactionData.changes.paymentTypeId)="row"
                >
                  <div
                    v-if="row.value == 1"
                    class="badge badge-soft-success font-size-12"
                  >
                    Cash Payment
                  </div>
                  <div
                    v-if="row.value == 2"
                    class="badge badge-soft-warning font-size-12"
                  >
                    Momo Payment
                  </div>
                </template>
                <template v-slot:cell(transactionType)="row">
                  <div
                    v-if="row.value == 'LoanPayment'"
                    class="badge badge-success font-size-12"
                  >
                    Loan Payment
                  </div>
                  <div
                    v-if="row.value == 'SavingsDeposit'"
                    class="badge badge-warning font-size-12"
                  >
                    Security Deposit
                  </div>
                  <div
                    v-if="row.value == 'Withdrawal'"
                    class="badge badge-danger font-size-12"
                  >
                    Withdrawal
                  </div>
                </template>
                <template v-slot:cell(notified)="row">
                  <div
                    v-if="row.value == true"
                    class="badge badge-soft-success font-size-12"
                  >
                    Message Sent
                  </div>
                  <div
                    v-if="row.value == false"
                    class="badge badge-soft-danger font-size-12"
                  >
                    Failed
                  </div>
                </template>
                <template v-slot:cell(_id)="row">
                  <router-link :to="`/agent/reversal/${row.value}`">
                    <b-button variant="danger" class="btn-sm">
                      <i class="ri-arrow-go-back-line"></i> Reverse
                    </b-button>
                  </router-link>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
